import { images } from "@/utils/images";
import { useTranslation } from "@/hooks/useTranslation";

export const MichelinBadge = ({ award, className }: { award: number, className?: string }) => {
  const { t } = useTranslation();
  
  const getMichelinText = (award: number) => {
    switch(award) {
      case 0: return t('michelin_selected');
      case 1: return t('michelin_1_star');
      case 2: return t('michelin_2_star');
      case 3: return t('michelin_3_star');
      default: return t('michelin_general');
    }
  };

  return (
    <div className={`inline-flex items-center gap-1 ml-2 mr-1 ${className}`}>
      <img src={images.michelinStar} alt="michelin star" className='w-4 h-4'/>
      <span className='text-sm text-red-600 font-semibold'>
        {getMichelinText(award)}
      </span>
    </div>
  )
}


export const BlueRibbonBadge = ({ ribbonType, className }: { ribbonType: number, className?: string }) => {
  const { t } = useTranslation();
  
  return (
    <div className={`inline-flex items-center gap-1 ml-2 mr-1 ${className}`}>
      <img src={images.blueRibbon} alt="blue ribbon" className='w-4 h-4'/>
      <span className='text-sm text-blue-600 font-semibold'>
        {`${ribbonType}${t('blueribbon_count_suffix')}`}
      </span>
    </div>
  )
}

export const PriceRangeBadge = ({ priceRange }: { priceRange: number }) => {
  return (
    <span className='text-gray-600 text-xs font-medium'>
      {Array.from({ length: priceRange }, (_, index) => '₩').join('')}
    </span>
  )
}

export const MichelinLogos = ({ count }: { count: number }) => {
  return (
    <div className='flex items-center gap-1'>
      {Array.from({ length: count }, (_, index) => (
        <img key={index} src={images.michelinStar} alt="michelinStar" className="w-4 h-4" />
      ))}
    </div>
  );
};

export const BlueRibbonLogos = ({ count }: { count: number }) => {
  return (
    <div className='flex items-center gap-1'>
      {Array.from({ length: count }, (_, index) => (
        <img key={index} src={images.blueRibbon} alt="blueRibbon" className="w-4 h-4" />
      ))}
    </div>
  );
};